import { defineStore } from 'pinia'
import { site } from '@/libs/api'

const getDefaultRegion = () =>
  window.location.hostname.endsWith('finsei.lv') ? 'lv' : 'uk'

export const useSettings = defineStore('settings', {
  state: () => ({
    available: false,
    settings: {
      title: null,
      description: null,
      brand_name: null,
      logo_file: null,
      js_url: null,
      css_url: null,
      favicon_url: null,
      email_support: null,
      email_compliance: null,
    },
  }),
  actions: {
    /**
     * Load list of available settings
     *
     * @param {string} [region] - License region (uk, lv). Defaults to hostname.
     * @returns {Promise<void>}
     */
    getSettings(region) {
      const effectiveRegion = region ?? getDefaultRegion()

      return site.getInfo(effectiveRegion).then(({ data }) => {
        this.available = data.available.app
        this.settings = data.settings
      })
    },
  },
})
